import React, { useEffect, useState } from "react";

import Input from "../../../../UI/Input/Input";
import { checkValidity } from "../../../../shared/utility";
import classes from "./Description.css";
import { connect, useSelector, useDispatch } from "react-redux";
import ReactTooltip from "react-tooltip";
import { SERVICENOW_REASONS } from "../../../../shared/Constants";
import * as actions from "../../../../store/actions";

const Description = (props) => {
  const [valid, setValid] = useState(false);
  const dispatch = useDispatch();
  const reasonList = useSelector((state) => state.member['service_nowReasonList']);
  const reasonFailure = useSelector((state) => state.member.getReasonFailure);
  const initialState = {
    reason: {
      elementType: "select",
      elementConfig: {
        type: "text",
        id: "reason",
        placeholder: "Select One",
        options: [],
      },
      value: props.impactedMemberData ? props.impactedMemberData.reason : "",
      validation: {
        required: true,
      },
      disabled: props.impactedMemberData ? true : false,
      valid: false,
      touched: false,
      label: "Reason",
      inputType: "QuickSearch",
    },
    description: {
      elementType: "textarea",
      elementConfig: {
        type: "text",
        id: "description",
        placeholder: "Description",
        rows: 5,
        cols: 150,
        minLength: 2,
        maxLength: 1275,
      },
      value: props.impactedMemberData
        ? props.impactedMemberData.issueDescription
        : "",
      validation: {
        required: descriptionForm?.reason?.value === "Other",
        minlength: 2,
        maxlength: 1275,
      },
      disabled: props.impactedMemberData ? true : false,
      valid: true,
      touched: false,
      label: "Description",
      inputType: "QuickSearch",
    },
  };
  const [descriptionForm, setDescriptionForm] = useState(initialState);
  const inputChangedHandler = (event, inputIdentifier) => {
    let updatedForm = { ...descriptionForm };

    const updatedFormElement = { ...updatedForm[inputIdentifier] };
    updatedFormElement.value = event.target.value;
    let formIsValid = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    if (event.target.value) {
      const validation = checkValidity(
        updatedFormElement.value,
        updatedFormElement.validation
      );
      updatedFormElement.valid = validation.isValid;
    } else {
      updatedFormElement.valid = false;
    }
    if(inputIdentifier==='reason' && event.target.value==='Other') {
      updatedForm['description'].validation.required = true
      const validationDescription = checkValidity(
        updatedForm['description'].value,
        updatedForm['description'].validation
      );
      updatedForm['description'].valid = validationDescription.isValid
    } else {
      updatedForm['description'].validation.required = false
      updatedForm['description'].valid = true
    }
    setValid(updatedFormElement.valid);
    updatedFormElement.touched = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }
    setDescriptionForm(updatedForm);
    props.setDescriptionDetails(updatedForm);
  };

  useEffect(() => {
    if (descriptionForm.description.valid && descriptionForm.reason.valid) {
      props.isValid(true);
    } else {
      props.isValid(false);
    }
  }, [descriptionForm]);

      useEffect(()=>{
        const updatedForm = {}
        Object.keys(descriptionForm)
        .map((key)=>{
          const formCopy = {...descriptionForm[key]};
          formCopy.disabled = props.formDisabled;
          updatedForm[key]= formCopy;
        })
        setDescriptionForm(updatedForm)
      },[props.formDisabled])

  useEffect(() => {
    if (
      localStorage.getItem(SERVICENOW_REASONS) !== null && JSON.parse(localStorage.getItem(SERVICENOW_REASONS)).length!==0 && 
      descriptionForm.reason.elementConfig.options.length===0
    ) {
      let updatedForm = { ...descriptionForm };
      updatedForm.reason.elementConfig.options = JSON.parse(
        localStorage.getItem(SERVICENOW_REASONS)
      ).map((status) => ({
        disabled: false,
        value: status.reason,
        displayValue: status.reason,
      }));
      setDescriptionForm(updatedForm);
    } else if ((!localStorage.getItem(SERVICENOW_REASONS) || JSON.parse(localStorage.getItem(SERVICENOW_REASONS)).length===0)
       && !reasonFailure) {
      dispatch(actions.getFeatureReasonsList('service_now'));
    }
  }, [reasonList]);

  useEffect(()=>{
    let updatedForm = { ...descriptionForm };
    Object.keys(descriptionForm)
        .map((key)=>{
          const formCopy = {...descriptionForm[key]};
          formCopy.disabled = false;
          updatedForm[key]= formCopy;
        })
    updatedForm['description'].value = '';
    updatedForm['reason'].value = '';
    updatedForm['reason'].valid = false;
    setDescriptionForm(updatedForm);
    props.setDescriptionDetails(updatedForm);
  },[props.resetValues])

  useEffect(()=>{
    props.setDescriptionDetails(descriptionForm);
  },[])

  const descriptionFormDisplay = Object.keys(descriptionForm).map((key) => {
    const descriptionElement = descriptionForm[key];
    return (
      <div
        style={{
          display: "flex",
          // flexFlow: "column",
          // flex: "50%",
          margin: "10px",
        }}
        className="required-field"
      >
        <Input
          key={key}
          elementType={descriptionElement.elementType}
          elementConfig={descriptionElement.elementConfig}
          value={descriptionElement.value}
          invalid={!descriptionElement.valid}
          shouldValidate={descriptionElement.validation}
          touched={descriptionElement.touched}
          disabled={descriptionElement.disabled}
          label={descriptionElement.label}
          required={descriptionElement.validation?.required}
          changed={(event) => inputChangedHandler(event, key)}
          inputType={descriptionElement.inputType}
        />
      </div>
    );
  });

  return (
    <>
      <div className={classes.FormTitle}>
        {"Description"}
        &nbsp;
        <a data-tip data-for="description">
          <span className="fa fa-question-circle"></span>{" "}
        </a>
        <ReactTooltip id="description">
          <span>Please describe the incident</span>
        </ReactTooltip>
      </div>
      <div className={classes.box}>
        <div style={{ display: "flex", flexDirection:'column' }}>{descriptionFormDisplay}</div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    impactedMemberData: state.member.impactedMemberData,
  };
};

export default connect(mapStateToProps, null)(Description);
